<template>
  <div>
    <div v-if="small" class="text-truncate product-text">
      <small>
        <v-avatar size="14" :color="product.crop.color" class="mr-1"></v-avatar>
        <span v-if="showYear">{{ product.year }}</span>
        {{ getCropName(product) }}
        <span v-if="getCropVarietyName(product)"> ( {{ getCropVarietyName(product) }} ) </span>
      </small>
    </div>
    <div v-if="!small" class="text-truncate">
      <v-avatar size="24" :color="product.crop.color" class="mr-1"></v-avatar>
      <span v-if="showYear">{{ product.year }}</span>
      {{ getCropName(product) }}
      <span v-if="getCropVarietyName(product)"> ( {{ getCropVarietyName(product) }} ) </span>
    </div>
  </div>
</template>

<script>
import Product from '@/lib/product'

export default {
  name: 'ProductIndicatorComponent',
  props: {
    small: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    showYear: {
      type: Boolean,
      required: false,
      default: false,
    },
    showVariety: {
      type: Boolean,
      required: false,
      default: true,
    },
    circleIconLarge: {
      type: Boolean,
      required: false,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  methods: {
    getCropName(product) {
      return Product.getCropName(product)
    },
    getCropVarietyName(product) {
      if (this.showVariety) {
        return Product.getCropVarietyName(product)
      }
      return null
    },
  },
}
</script>

<style scoped></style>
